import React, { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import { FaBookOpen, FaSpinner } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrdersOfUser } from "../../../redux/action/order";
import RecieptPopup from "../Order/RecieptPopup";
import Cookies from 'js-cookie'
import { addToCart } from "../../../redux/action/cart"; // Assuming you have an action for this
import { toast } from "react-toastify";
import { showCustomAlert } from "../Signup/Toast";
import Swal from "sweetalert2";
const UserOrder = () => {
  const { isLoading, orders } = useSelector((state) => state.order);
  // console.log("🚀 ~ UserOrder ~ orders:", orders);
  const { user } = useSelector((state) => state.user);
  const { cart } = useSelector((state) => state.cart);
    const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))
    const statusRes =  Cookies.get(`restaurantStatus_${RestaurantSavedId}`)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const restaurantId =  localStorage.getItem('selectedRestaurantId')
  
  console.log("restaurantId",restaurantId);
  
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 5;
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state

  const results = orders?.results || [];
  const totalPages = orders?.totalPages || 1;
  const sortBy = "createdAt:desc"; // Sorting logic
  const handlePageChange = (pageNumber) => {
    setCurrentPage((prev) => Math.max(1, Math.min(pageNumber, totalPages)));
  };

  useEffect(() => {
    if (user?._id) {
      dispatch(getAllOrdersOfUser(user._id, currentPage, ordersPerPage, sortBy, restaurantId));
    }
  }, [currentPage, user?._id, sortBy, dispatch, restaurantId]);

  const handleReceiptPopup = (order) => {
    setSelectedOrder(order);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedOrder(null);
  };

  const addToCartHandler = (product, quantity = 1, discountValue = 0) => {
    // Ensure the comparison matches the structure of your product and cart
    const isItemExists = cart.find((item) => item.productId === product.productId);  

    console.log("isItemExists", isItemExists); // Debugging output

    const discountAmount = (product.price * discountValue) / 100;
    const finalPrice = (product.price - (discountAmount || 0)).toFixed(2);

    if (isItemExists) {
        const updatedProduct = {
            ...isItemExists,
            quantity: isItemExists.quantity + quantity, // Add the correct quantity
        };
        dispatch(addToCart(updatedProduct));
    } else {
        // Add the product if it doesn't exist
        dispatch(addToCart({ ...product, quantity, price: finalPrice }));
    }
};

const handleReorder = (order) => {
  if (statusRes === 'closed') {
    showCustomAlert({
      title: 'Restaurant is closed!',
      html: '<p style="color: #555;">Restaurant is not accepting orders right now</p>',
      icon: 'success',
      confirmButtonText: 'ok',
      confirmButtonColor: '#af313d',
      background: '#ffffff',
      timer: 4000
    });
  } else {
    order.items.forEach((item) => {
      addToCartHandler(item, item.quantity); // Pass correct quantity
    });

    Swal.fire({
      title: 'Order Readded!',
      html: '<p style="color: #555;">Your previous order has been added to the cart. Proceed to checkout to complete your purchase.</p>',
      icon: 'success',
      confirmButtonText: 'Checkout',
      confirmButtonColor: '#af313d',
      background: '#ffffff',
      timer: null
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/my-cart');
      }
    });
  }
};

  return (
    <>
      <section className="flex justify-center items-center overflow-x-hidden px-16 py-6 lg:h-[142px] bg-[#AF313D] text-white text-6xl font-bold relative">
        <Link
          to="/dashboard"
          className="absolute left-6 top-1/2 transform -translate-y-1/2"
        >
          <GoArrowLeft className="text-2xl cursor-pointer" />
        </Link>
        <h1 className="text-4xl md:text-5xl">Orders Details</h1>
      </section>

      <div className="md:w-[90%] w-full md:mx-auto ml-1  mt-6  overflow-x-hidden">
        {isLoading ? (
          <div className="flex justify-center items-center min-h-screen">
            <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
          </div>
        ) : (
          <>
            <table className="w-full text-left border-collapse overflow-x-hidden">
              <thead>
                <tr className="bg-[#AF313D] text-white text-lg font-bold">
                  <th className="px-0 md:px-4 py-3 text-center body text-[12px] md:text-[16px]">
                    Date & Time
                  </th>
                  {/* <th className="px-0 md:px-4 py-3 text-center body text-[12px] md:text-[16px]">
                    Order Number
                  </th> */}
                  <th className="px-0 md:px-4 py-3 text-center body text-[12px] md:text-[16px]">
                    Amount
                  </th>
                  <th className="px-0 md:px-4 py-3 text-center body text-[12px] md:text-[16px]">
                    Summary
                  </th>
                  <th className="px-0 md:px-4 py-3 text-center body text-[12px] md:text-[16px]">
                    Order Status
                  </th>
                  <th className="px-0 md:px-4 py-3 text-center body text-[12px] md:text-[16px]">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className=" overflow-x-hidden">
                {results.map((order, index) => (
                  <tr
                    key={order._id || index}
                    className="bg-white border-b hover:bg-gray-100"
                  >
                    {/* Date & Time */}
                    <td className="px-0 md:px-4 py-3 text-center body text-[12px] md:text-[16px] text-gray-700">
                      {new Date(order.createdAt).toLocaleDateString()} <br />
                      <span className="text-gray-500">
                        {new Date(order.createdAt).toLocaleTimeString()}
                      </span>
                    </td>

                    {/* Order Number */}
                    {/* <td className="px-4 py-3 text-center body text-[12px] md:text-[16px] text-gray-700">
                      {order.orderNo}
                    </td> */}

                    {/* Amount */}
                    <td className="px-4 py-3 text-center body text-[12px] md:text-[16px] text-gray-700">
                      &pound;{order.totalPrice}
                    </td>

                    {/* Summary */}
                    <td className="px-4 py-3 mt-3 text-center body text-[12px] md:text-[16px] flex flex-col items-center justify-center">
                      <FaBookOpen
                        className="text-xl text-[#C97C2A] cursor-pointer"
                        onClick={() => handleReceiptPopup(order)}
                      />
                    </td>

                    {/* Order Status */}
                    <td className="px-4 py-3 text-center body text-[12px] md:text-[16px]">
                      <button
                        className="bg-[#AF313D] text-white px-4 py-2 rounded hover:bg-[#90242B]"
                        onClick={() => navigate(`/order-status-order/${order._id}`)}
                      >
                        View Status
                      </button>
                    </td>
                    {/* Reorder Button */}
                    <td className="px-4 py-3 text-center body text-[12px] md:text-[16px]">
                      <button
                        className="bg-[#C97C2A] text-white px-4 py-2 rounded hover:bg-[#af5c1a]"
                        onClick={() => handleReorder(order)}
                      >
                        Reorder
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {results.length === 0 && (
              <div className="text-center body text-[12px] md:text-[16px] py-6 text-gray-500">
                No orders found.
              </div>
            )}
          </>
        )}
      </div>

      <div className="flex justify-end items-center gap-2 mt-6">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded ${
            currentPage === 1
              ? "text-gray-400 cursor-not-allowed"
              : "text-[#C97C2A] hover:bg-[#f1e3d5]"
          }`}
        >
          &laquo;
        </button>

        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            onClick={() => handlePageChange(index + 1)}
            className={`px-3 py-1 rounded ${
              currentPage === index + 1
                ? "bg-[#C97C2A] text-white"
                : "text-[#C97C2A] hover:bg-[#f1e3d5]"
            }`}
          >
            {index + 1}
          </button>
        ))}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 rounded ${
            currentPage === totalPages
              ? "text-gray-400 cursor-not-allowed"
              : "text-[#C97C2A] hover:bg-[#f1e3d5]"
          }`}
        >
          &raquo;
        </button>
      </div>

      {showPopup && (
        <RecieptPopup orderData={selectedOrder} closePopup={closePopup} />
      )}
    </>
  );
};

export default UserOrder;
